import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Header from '../elements/Header';
import ListButton from '../elements/ListButton';
import { __ } from 'i18n-for-browser';

import Team from '../../assets/img/icons/economy/team.svg';
import economy from '../../assets/img/icons/economy/economy.svg';
import {connect} from "react-redux";
import EconomyTotal from "../elements/EconomyTotal";
import EconomyEarned from "../elements/EconomyEarned";

class Economy extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      viewComponent: true,
      economyViewType: this.props.match.params.id,
    }
  };

  render() {
    const { gameState, feedback } = this.props;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];

    if(!gameState.prevRound || !feedback.prevRoundFeedbackData) return null;

    return (
      <div>
        <Header history={this.props.history} historic={false} buttonType={'close'} showTitle={false}/>

        <div className={'container single-economy ministries-list'}>
          <div className={"economy-list"}>

            { this.state.viewComponent && this.state.economyViewType === 'total' &&
              <div>
                <ListButton
                  bgColor='darkblue'
                  title={__("sim_totalglobas")}
                  className={'total-economy-list-button'}
                  icon={economy}
                  globas={gameState.totalEconomy}
                  points={0}/>
                <EconomyTotal/>

              </div>
            }

            { this.state.viewComponent && this.state.economyViewType === 'earned' &&
              <div>

                <ListButton
                  bgColor='blue'
                  title={__("sim_earnedglobas")}
                  icon={Team}
                  globas={currentRoundGameState.earnedGlobas}
                  points={currentRoundGameState.earnedPoints}/>

                <EconomyEarned/>
              </div>

            }

          </div>
        </div>

      </div>
    )
  }

}

export default connect(({gameState, feedback, schoolClass}) => ({gameState, feedback, schoolClass}))(Economy);



// WEBPACK FOOTER //
// ./src/components/routes/Economy.js